module.exports = "/images/ofertadescuenta.svg";